/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_SponsoredInputs */

const en_directory_tool_sponsored = /** @type {(inputs: Directory_Tool_SponsoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored`)
};

const zh_directory_tool_sponsored = /** @type {(inputs: Directory_Tool_SponsoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助`)
};

/**
* | output |
* | --- |
* | "Sponsored" |
*
* @param {Directory_Tool_SponsoredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_sponsored = /** @type {((inputs?: Directory_Tool_SponsoredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_SponsoredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_sponsored(inputs)
	return zh_directory_tool_sponsored(inputs)
});
export { directory_tool_sponsored as "directory.tool.sponsored" }